const template      = require('commons/templates/Main.ejs');
const navMenuTpl    = require('../templates/NavMenu.ejs');
const tooltip       = require('helpers/tooltip');
const QueryString   = require('query-string');

module.exports = Backbone.View.extend({
    el: '.content',
    childEl: '#main-area',

    events: {
        'click .js-free-account-setup': 'freeAccountSetup'
    },

    initialize: function() {
        this.render();
    },

    render: function() {
        const id = app.company.get('mppAdminId');
        const logoUrl = app.user.getLogoUrl(id);
        let params = QueryString.parse(window.location.search);

        this.$el.html(template({
            navMenu: navMenuTpl({
                userName: app.user.get('name'),
                companyName: app.company ?
                    app.company.get('companyName') || '' : '',
                isAdmin: (params && params.employee)
            }),
            headerMenu: null,
            version: app.version,
            whitelabel: (
                app.company.get('mppAdminId') ||
                (app.subscription && app.subscription.get('plan') !== 'client')
            ),
            logoUrl: logoUrl
        }));

        $('body').removeClass('gray-bg');

        this.$('#side-menu').metisMenu({
            toggle:      false,
            activeClass: 'active-group'
        });

        this.$el.find('.logo img')
            .on('load', (e) => {
                $(e.target.parentElement).removeClass('hidden');
            })
            .on('error', (e) => {
                e.target.src = '';
            });

        tooltip.initBody();
    },

    setActiveLink: function(route) {
        this.$el.find('#side-menu li').removeClass('active');

        this.$el.find('#side-menu a[href="#' + route + '"]').parent()
            .addClass('active');
    }
});



// WEBPACK FOOTER //
// ./app/employee/views/Main.js